import { useReveal } from "../lib/useReveal";
import { useParallax } from "../lib/useParallax";

const ABOUT_IMG =
  "https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/vwp5tm5d_WhatsApp%20Image%202026-04-24%20at%204.05.20%20PM.jpeg";

export default function About() {
  const ref = useReveal();
  const imgRef = useParallax(0.12);
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#F4F1EA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div ref={ref} className="reveal grid lg:grid-cols-12 gap-10 lg:gap-20 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5]">
              <img
                ref={imgRef}
                src={ABOUT_IMG}
                alt="A cow walking on a rural road"
                className="absolute -top-[10%] left-0 w-full h-[120%] object-cover will-change-transform"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B4D3E]/60 via-transparent to-transparent" />
              <div className="absolute left-6 bottom-6 right-6">
                <div className="text-[#D4AF37] text-xs tracking-[0.3em] uppercase">
                  The Bokadia Family
                </div>
                <div className="font-display italic text-[#FDFBF7] text-2xl md:text-3xl mt-2 leading-snug">
                  "Seva is not charity — it is a way of life."
                </div>
              </div>
            </div>

            <div className="mt-8 grid grid-cols-3 gap-4 text-center">
              <div className="p-4 border border-[#E3DECE] rounded-xl bg-[#FDFBF7]">
                <div className="font-display text-3xl text-[#1B4D3E]">24/7</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#7A8C81] mt-1">Care</div>
              </div>
              <div className="p-4 border border-[#E3DECE] rounded-xl bg-[#FDFBF7]">
                <div className="font-display text-3xl text-[#1B4D3E]">100+</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#7A8C81] mt-1">Rescues / mo</div>
              </div>
              <div className="p-4 border border-[#E3DECE] rounded-xl bg-[#FDFBF7]">
                <div className="font-display text-3xl text-[#1B4D3E]">3+</div>
                <div className="text-[11px] tracking-[0.2em] uppercase text-[#7A8C81] mt-1">Generations</div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-[1px] w-10 bg-[#D4AF37]" />
              <span className="text-xs tracking-[0.3em] uppercase text-[#4A5D53]">
                Our Story
              </span>
            </div>

            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A2E24] leading-[1.05]">
              A home built on <span className="italic text-[#1B4D3E]">seva</span>, stewarded by the <span className="italic">Bokadia Family</span>.
            </h2>

            <div className="mt-10 space-y-6 text-[#4A5D53] leading-relaxed text-lg">
              <p>
                Hastkesar Panjrapole began as a vow — to never turn away an
                animal in pain. Today it is a sprawling refuge where rescued
                all animals are treated with the same dignity
                we would offer our own.
              </p>
              <p>
                Our team of veterinarians, caretakers and volunteers run a
                full-scale animal hospital, gaushala, and rehabilitation
                programme. From newborn calves to road-accident survivors, every
                life is received with care and without conditions.
              </p>
              <p>
                Run for decades by the Bokadia Family, our home continues
                to grow — but our promise has never changed: <span className="text-[#1B4D3E] font-medium">compassion, without limits</span>.
              </p>
            </div>

            <div className="mt-12 flex flex-wrap gap-8 items-center">
              {["Animal Rescue", "Medical Treatment", "Shelter & Long-term Care", "Community Awareness"].map(
                (t) => (
                  <div key={t} className="flex items-center gap-2 text-sm text-[#1A2E24]">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]" />
                    {t}
                  </div>
                )
              )}
            </div>

            {/* Trustees Tribute */}
            <div className="mt-16">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-[1px] w-10 bg-[#D4AF37]" />
                <span className="text-[11px] tracking-[0.3em] uppercase text-[#4A5D53]">
                  Our Trustees
                </span>
              </div>
              <div className="grid md:grid-cols-2 gap-5">
                {/* Trustee 1 — Babulal */}
                <div className="relative bg-[#FDFBF7] border border-[#E3DECE] rounded-2xl p-8 overflow-hidden">
                  <div className="absolute -top-6 -right-6 w-28 h-28 rounded-full border border-[#D4AF37]/40 pointer-events-none" />
                  <div className="absolute -top-10 -right-10 w-36 h-36 rounded-full border border-[#D4AF37]/20 pointer-events-none" />
                  <div className="flex items-center gap-4">
                    <div className="shrink-0 w-16 h-16 rounded-full overflow-hidden ring-2 ring-[#D4AF37]/40">
                      <img
                        src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/3fvvvqtr_704d61a4-db5f-472b-8555-3a09eed78f03.jpg"
                        alt="Shri Babulal Hastimalji Bokadia"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                        Founder & Trustee
                      </div>
                      <h3 className="mt-1 font-display text-xl md:text-2xl text-[#1A2E24] leading-tight">
                        Shri Babulal Hastimalji Bokadia
                      </h3>
                    </div>
                  </div>
                  <p className="mt-6 text-[#4A5D53] leading-relaxed text-[15px]">
                    Founded with a heartfelt mission to care for injured and abandoned animals,
                    <span className="text-[#1B4D3E] font-medium"> Shree Hasthkeshar Panjrapole </span>
                    stands today as a symbol of compassion. The vision of trustee
                    <span className="text-[#1B4D3E] font-medium"> Shri Babulal Hastimalji Bokadia </span>
                    continues to shape its journey — honouring the family's enduring tradition of
                    kindness towards all living beings.
                  </p>
                </div>

                {/* Trustee 2 — Jitendra */}
                <div className="relative bg-[#FDFBF7] border border-[#E3DECE] rounded-2xl p-8 overflow-hidden">
                  <div className="absolute -top-6 -right-6 w-28 h-28 rounded-full border border-[#D4AF37]/40 pointer-events-none" />
                  <div className="absolute -top-10 -right-10 w-36 h-36 rounded-full border border-[#D4AF37]/20 pointer-events-none" />
                  <div className="flex items-center gap-4">
                    <div className="shrink-0 w-16 h-16 rounded-full overflow-hidden ring-2 ring-[#D4AF37]/40">
                      <img
                        src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/7lpthebd_WhatsApp%20Image%202026-04-25%20at%2012.00.29%20AM.jpeg"
                        alt="Shri Jitendra Hastimalji Bokadia"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                        Co-Trustee
                      </div>
                      <h3 className="mt-1 font-display text-xl md:text-2xl text-[#1A2E24] leading-tight">
                        Shri Jitendra Hastimalji Bokadia
                      </h3>
                    </div>
                  </div>
                  <p className="mt-6 text-[#4A5D53] leading-relaxed text-[15px]">
                    Supporting the vision alongside his elder brother,
                    <span className="text-[#1B4D3E] font-medium"> Shri Jitendra Hastimalji Bokadia </span>
                    plays a key role in the growth of Shree Hasthkeshar Panjrapole. His dedication
                    and hands-on involvement ensure that the values of compassion and service
                    continue to thrive across generations.
                  </p>
                </div>
              </div>
            </div>

            {/* In Loving Memory */}
            <div className="mt-16">
              <div className="flex items-center gap-3 mb-6">
                <span className="h-[1px] w-10 bg-[#D4AF37]" />
                <span className="text-[11px] tracking-[0.3em] uppercase text-[#4A5D53]">
                  In their loving memory
                </span>
              </div>
              <h3 className="font-display text-3xl md:text-4xl text-[#1A2E24] leading-[1.1] mb-8">
                The hearts whose <span className="italic text-[#1B4D3E]">legacy</span> we carry forward.
              </h3>

              <div className="grid md:grid-cols-2 gap-5">
                {/* Father */}
                <article
                  data-testid="memory-father"
                  className="relative bg-[#FDFBF7] border border-[#E3DECE] rounded-2xl overflow-hidden flex flex-col"
                >
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img
                      src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/duh80tbi_WhatsApp%20Image%202026-04-25%20at%208.28.08%20PM.jpeg"
                      alt="Our father — in loving memory"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#1A2E24]/70 to-transparent" />
                    <div className="absolute left-5 bottom-5 right-5">
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                        In loving memory
                      </div>
                      <div className="font-display italic text-[#FDFBF7] text-2xl mt-1">
                        Our Father
                      </div>
                    </div>
                  </div>
                  <div className="p-7 md:p-8">
                    <p className="text-[#4A5D53] leading-relaxed text-[15px]">
                      This initiative is a humble tribute to our father, whose
                      life was defined by <span className="text-[#1B4D3E] font-medium">strength, integrity, and selfless values</span>.
                      Though he is no longer with us, his teachings continue to
                      guide every step we take. In his honour, his sons have
                      devoted themselves to carrying forward his vision through
                      service and compassion, ensuring that his legacy lives on
                      in every life touched by this NGO.
                    </p>
                  </div>
                </article>

                {/* Mother */}
                <article
                  data-testid="memory-mother"
                  className="relative bg-[#FDFBF7] border border-[#E3DECE] rounded-2xl overflow-hidden flex flex-col"
                >
                  <div className="relative aspect-[4/5] overflow-hidden">
                    <img
                      src="https://customer-assets.emergentagent.com/job_cow-rescue-hospital/artifacts/gq974sdw_WhatsApp%20Image%202026-04-25%20at%208.32.57%20PM.jpeg"
                      alt="Our mother — in loving honour"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t from-[#1A2E24]/70 to-transparent" />
                    <div className="absolute left-5 bottom-5 right-5">
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
                        With deepest gratitude
                      </div>
                      <div className="font-display italic text-[#FDFBF7] text-2xl mt-1">
                        Our Mother
                      </div>
                    </div>
                  </div>
                  <div className="p-7 md:p-8">
                    <p className="text-[#4A5D53] leading-relaxed text-[15px]">
                      This initiative is dedicated to our mother, a
                      living embodiment of <span className="text-[#1B4D3E] font-medium">compassion, resilience, and grace</span>.
                      Her presence continues to inspire and guide us with warmth
                      and wisdom. In her honour, her sons have devoted themselves
                      to serving others, reflecting her values of kindness,
                      humility, and unconditional care through the work of this NGO.
                    </p>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
